import { mapState } from 'vuex'
import listItemTeam from '@/components/list-item-team/list-item-team.vue'
import groupTable from '@/components/group-table/group-table.vue'
import timelineItemMatch from '@/components/timeline-item-match/timeline-item-match.vue'

export default {
  components: {
    listItemTeam,
    groupTable,
    timelineItemMatch
  },
  data () {
    return {
      editMode: false
    }
  },
  computed: {
    ...mapState(['groups', 'teams', 'matches', 'user']),
    group () {
      return this.groups[this.$route.params.groupId - 1] || null
    },
    groupTeams () {
      return Object.values(this.teams).filter(t => t.assignedGroup === this.group.index)
    },
    nextMatches () {
      return this.matches
        .filter(m => !m.hasFinished && m.group === this.group.index)
    },
    prevMatches () {
      return this.matches
        .filter(m => m.hasFinished && m.group === this.group.index)
    }
  }
}
